import { noop } from 'lodash'
import React, { useState } from 'react'
import {
  DEFAULT_MERCHANT_LOGO,
  DEFAULT_MERCHANT_BACKGROUND
} from './lib/client-constants'

interface Props {
  src: string
  className?: string
  alt?: string
  backgroundColor?: string
  onLoad?: Function
}

const Logo = ({
  className,
  src,
  alt,
  backgroundColor = '',
  onLoad = noop
}: Props) => {
  const [imageSrc, setImageSrc] = useState(src || DEFAULT_MERCHANT_LOGO)
  const [imageBgc, setimageBgc] = useState(backgroundColor)

  const handleError = () => {
    setimageBgc(DEFAULT_MERCHANT_BACKGROUND)
    setImageSrc(DEFAULT_MERCHANT_LOGO)
  }

  const handleLoadImage = (_e: React.SyntheticEvent<HTMLImageElement>) => {
    onLoad()
  }

  return (
    <img
      className={className}
      src={imageSrc}
      style={{ backgroundColor: imageBgc }}
      alt={alt}
      data-is-default-image={imageSrc === DEFAULT_MERCHANT_LOGO}
      onError={handleError}
      onLoad={handleLoadImage}
    />
  )
}

export default Logo
